import React, { useState } from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function SummarySection() {
  const [selectedPlan, setSelectedPlan] = useState<'basic' | 'premium'>('premium');
  return <section className="py-20 px-4 bg-white" data-id="element-246">
      <div className="max-w-3xl mx-auto" data-id="element-247">
        {/* Warning Alert */}
        <div className="bg-red-50 border-2 border-red-200 rounded-2xl p-6 md:p-8 mb-16 text-center shadow-sm" data-id="element-248">
          <h3 className="text-2xl font-black text-red-600 mb-4 flex items-center justify-center gap-2" data-id="element-249">
            ⚠️ ATENCIÓN: Este precio es de lanzamiento
          </h3>
          <p className="text-gray-800 text-lg mb-4" data-id="element-250">
            El <strong data-id="element-251">MÉTODO CALMA®</strong> está disponible hoy por{' '}
            <strong data-id="element-252">$19.990</strong> o <strong data-id="element-253">$29.990</strong> con el
            Acelerador incluido.
          </p>
          <p className="text-gray-800 text-lg mb-6" data-id="element-254">
            Pero este precio{' '}
            <strong className="underline decoration-red-400 decoration-4" data-id="element-255">
              no va a durar.
            </strong>
          </p>
          <div className="text-gray-600 italic space-y-2 mb-6" data-id="element-256">
            <p data-id="element-257">Cada día que pasa es un día más de rabietas sin herramientas.</p>
            <p data-id="element-258">Un día más de gritos que no querés dar.</p>
            <p data-id="element-259">Un día más de culpa que no merecés sentir.</p>
          </div>
          <p className="text-xl font-bold text-gray-900" data-id="element-260">
            El cambio empieza con una decisión.
            <br data-id="element-261" />
            <span className="text-green-600" data-id="element-262">
              Y esa decisión cuesta menos que una cena afuera.
            </span>
          </p>
        </div>

        {/* Summary Box */}
        <div className="border-4 border-gray-900 rounded-2xl p-6 md:p-10 bg-gray-50 shadow-2xl" data-id="element-263">
          <h2 className="text-2xl md:text-3xl font-black text-center text-gray-900 mb-8 uppercase tracking-wide" data-id="element-264">
            📦 RESUMEN DE TODO LO QUE LLEVÁS
          </h2>

          <div className="space-y-3 mb-8" data-id="element-265">
            {['Tomo 1 — Fundamentos CALMA', 'Tomo 2 — Tablero de Rutinas Mágicas', 'Tomo 3 — Rabietas con Calma', 'Tomo 4 — Diccionario de las Emociones', 'Tomo 5 — Disciplina Sin Gritos', 'Tomo 6 — Diario de la Madre Calmada'].map((item, i) => <div key={i} className="flex justify-between items-center border-b border-gray-200 pb-2" data-id="element-266">
                <div className="flex items-center gap-2" data-id="element-267">
                  <CheckIcon className="w-5 h-5 text-green-500" data-id="element-268" />
                  <span className="font-medium text-gray-800" data-id="element-269">{item}</span>
                </div>
                <span className="text-gray-400 line-through text-sm" data-id="element-270">
                  $15.000
                </span>
              </div>)}

            {['Bono 1 — El Mapa de Triggers', 'Bono 2 — Tablero de Recompensas Sin Sobornos', 'Bono 3 — Kit Anti-Pantallas', 'Bono 4 — La Guía de Acuerdos Familiares'].map((item, i) => <div key={i} className="flex justify-between items-center border-b border-gray-200 pb-2 bg-yellow-50/50 px-2 -mx-2" data-id="element-271">
                <div className="flex items-center gap-2" data-id="element-272">
                  <GiftIcon className="w-5 h-5 text-yellow-500" data-id="element-273" />
                  <span className="font-bold text-gray-800" data-id="element-274">{item}</span>
                </div>
                <span className="text-gray-400 line-through text-sm" data-id="element-275">
                  $9.000
                </span>
              </div>)}

            <div className="flex justify-between items-center pt-2 px-2 bg-green-50 rounded" data-id="element-276">
              <div className="flex items-center gap-2" data-id="element-277">
                <span className="text-xl" data-id="element-278">🔒</span>
                <span className="font-black text-green-800" data-id="element-279">
                  Garantía 7 días
                </span>
              </div>
              <span className="font-black text-green-600" data-id="element-280">INCLUIDA</span>
            </div>
          </div>

          <div className="text-center mb-8" data-id="element-281">
            <p className="text-gray-500 font-bold tracking-widest uppercase mb-1" data-id="element-282">
              VALOR TOTAL REAL:
            </p>
            <p className="text-3xl text-gray-400 line-through font-black" data-id="element-283">
              $126.000
            </p>
          </div>

          <div className="space-y-4 mb-10" data-id="element-284">
            {/* Plan 1: Basic - Selectable */}
            <div onClick={() => setSelectedPlan('basic')} className={`rounded-xl p-4 flex flex-col sm:flex-row justify-between items-center gap-3 text-center sm:text-left cursor-pointer transition-all duration-300 ${selectedPlan === 'basic' ? 'bg-green-50 border-2 border-green-500 shadow-md scale-[1.02]' : 'bg-white border-2 border-gray-200 hover:border-gray-300'}`} data-id="element-285">
              <div className="flex items-center gap-3" data-id="element-286">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selectedPlan === 'basic' ? 'border-green-500' : 'border-gray-300'}`} data-id="element-287">
                  {selectedPlan === 'basic' && <div className="w-2.5 h-2.5 bg-green-500 rounded-full" data-id="element-288" />}
                </div>
                <span className="font-bold text-gray-700" data-id="element-289">
                  📘 MEGAPACK COMPLETO
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-290">
                <span className="text-gray-400 line-through text-sm" data-id="element-291">
                  $126.000
                </span>
                <span className="text-gray-400" data-id="element-292">→</span>
                <span className="text-2xl font-black text-gray-900" data-id="element-293">
                  $19.990
                </span>
              </div>
            </div>

            {/* Plan 2: Premium - Selectable (Default) */}
            <div onClick={() => setSelectedPlan('premium')} className={`rounded-xl p-4 flex flex-col sm:flex-row justify-between items-center gap-3 text-center sm:text-left cursor-pointer transition-all duration-300 relative ${selectedPlan === 'premium' ? 'bg-slate-900 border-2 border-yellow-400 shadow-2xl scale-105' : 'bg-slate-800 border-2 border-slate-600 hover:border-slate-500'}`} data-id="element-294">
              {/* MÁS ELEGIDO badge */}
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 sm:left-auto sm:translate-x-0 sm:right-4" data-id="element-295">
                <span className="bg-yellow-400 text-yellow-900 text-[10px] font-black px-3 py-1 rounded-full shadow-md uppercase tracking-wider" data-id="element-296">
                  ⭐ MÁS ELEGIDO
                </span>
              </div>
              <div className="flex items-center gap-3 mt-2 sm:mt-0" data-id="element-297">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center flex-shrink-0 ${selectedPlan === 'premium' ? 'border-yellow-400' : 'border-slate-500'}`} data-id="element-298">
                  {selectedPlan === 'premium' && <div className="w-2.5 h-2.5 bg-yellow-400 rounded-full" data-id="element-299" />}
                </div>
                <span className="font-black text-white flex items-center gap-2 text-sm md:text-base" data-id="element-300">
                  🏆 PREMIUM + ACELERADOR + BOTIQUÍN
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-301">
                <span className="text-slate-400 line-through text-sm" data-id="element-302">
                  $180.000
                </span>
                <span className="text-slate-400" data-id="element-303">→</span>
                <span className="text-3xl font-black text-yellow-400" data-id="element-304">
                  $29.990
                </span>
              </div>
            </div>
          </div>

          <CTAButton subtext="Acceso inmediato · PDF descargable · Garantía 7 días" data-id="element-305" />
        </div>
      </div>
    </section>;
}